<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { RouterLink } from 'vue-router'
import ArrowIcon from '@/components/shared/ArrowIcon.vue'
import MarketingHeroArt from '@/components/marketing/MarketingHeroArt.vue'
import { HERO_IMAGES } from '@/assets/marketing/heroes/images'

const { t } = useI18n()
</script>

<template>
  <section class="relative min-h-screen bg-slate-900 flex items-center justify-center overflow-hidden">
    <MarketingHeroArt v-bind="HERO_IMAGES.participants" />
    <div
      class="absolute inset-0 pointer-events-none"
      style="background: radial-gradient(ellipse 80% 60% at 50% 40%, rgba(2,132,199,0.12) 0%, transparent 70%);"
    ></div>

    <div class="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto py-24">
      <div class="inline-flex items-center bg-sky-500/10 text-sky-400 text-sm font-medium px-4 py-1.5 rounded-full mb-8">
        🏃 {{ t('participants_lp.hero.badge') }}
      </div>

      <h1 class="text-4xl md:text-6xl lg:text-7xl font-black text-white leading-tight">
        {{ t('participants_lp.hero.headline') }}
      </h1>

      <p class="text-lg md:text-xl text-slate-400 mt-6 max-w-2xl mx-auto leading-relaxed">
        {{ t('participants_lp.hero.subheadline') }}
      </p>

      <div class="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
        <RouterLink
          to="/my/login"
          class="inline-flex items-center justify-center gap-2 bg-sky-600 hover:bg-sky-500 text-white font-semibold rounded-lg px-8 py-4 text-base transition-colors"
        >
          {{ t('participants_lp.hero.cta_primary') }}
          <ArrowIcon direction="right" class="w-4 h-4" />
        </RouterLink>
        <RouterLink
          to="/my/login"
          class="inline-flex items-center justify-center gap-2 border-2 border-white text-white hover:bg-white hover:text-slate-900 font-semibold rounded-lg px-8 py-4 text-base transition-colors"
        >
          {{ t('participants_lp.hero.cta_secondary') }}
          <ArrowIcon direction="right" class="w-4 h-4" />
        </RouterLink>
      </div>

      <div class="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-slate-500">
        <span>✓ {{ t('participants_lp.hero.chip_fast') }}</span>
        <span>✓ {{ t('participants_lp.hero.chip_secure') }}</span>
        <span>✓ {{ t('participants_lp.hero.chip_one_login') }}</span>
      </div>

      <div class="mt-12 flex justify-center">
        <ArrowIcon direction="down" class="w-6 h-6 text-slate-600 animate-bounce" />
      </div>
    </div>
  </section>
</template>
